import { AppFooter } from "./AppFooter";
import { AppHeader } from "./AppHeader";
import { HomePage } from "./home/HomePage";

export function Home()  {
    return (
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
            </div>    
        </div> 
        <div class="m-0 p-0 row align-items-top">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <div class="homepageheight">
                    <HomePage/>
                </div>
            </div>
        </div>
        <div class="m-0 p-0 row">
            <div class="m-0 p-0 col-sm-12 col-md-12">
            <AppFooter/>
            </div>    
        </div> 
    </>
  );
}
